export default __webpack_public_path__ + "static/media/land.7aa44d6e.png";